<template>
  <section class="contacts-table-wrap">
    <div class="search-wrap">
      <h2>Não adicionados</h2>
      <input
        type="text"
        :placeholder="$t('CONTACTS_PAGE.SEARCH_INPUT_PLACEHOLDER')"
        class="contact-added-search"
        :value="searchQuery"
        @keyup.enter="onSearchSubmit"
        @input="onInputSearch"
      />
    </div>
    <div>
      <label
        v-if="selectContactsLength > 0"
        class="bulk-action__panel flex-start"
      >
        <input
          type="checkbox"
          class="checkbox"
          :checked="allContactsSelected"
          :indeterminate.prop="!allContactsSelected"
          @change="handleSelectAll($event)"
        />
        <span>
          {{
            $t('BULK_ACTION.CONTACTS_SELECTED', {
              contactsCount: selectContactsLength,
            })
          }}
        </span>
      </label>
    </div>
    <div @mouseleave="onCardLeave">
      <ve-table
        :key="selectedContacts.length"
        :fixed-header="true"
        min-height="400px"
        scroll-width="100rem"
        :checkbox-option="checkboxOption"
        :columns="columns"
        :table-data="tableList"
        :border-around="false"
        :sort-option="sortOption"
        row-key-field-name="id"
      />
    </div>
    <div v-if="meta && meta.count > 15" class="pagination-controls">
      <button
        class="pagination-btn"
        :disabled="currentPage === 1 || isLoading"
        @click="goToPage(currentPage - 1)"
      >
        &lt;
      </button>
      <span class="pagination-current">
        {{ currentPage }}/{{
          Math.ceil((meta.count - selectedContacts.length) / 15)
        }}
      </span>
      <button
        class="pagination-btn"
        :disabled="
          currentPage ===
            Math.ceil((meta.count - selectedContacts.length) / 15) || isLoading
        "
        @click="goToPage(currentPage + 1)"
      >
        &gt;
      </button>
    </div>
    <empty-state
      v-if="showSearchEmptyState"
      :title="$t('CONTACTS_PAGE.LIST.404')"
    />
    <empty-state
      v-else-if="!isLoading && !tableData.length"
      :title="$t('CONTACTS_PAGE.LIST.NO_CONTACTS')"
    />
    <div v-if="isLoading" class="contacts--loader">
      <spinner />
      <span>{{ $t('CONTACTS_PAGE.LIST.LOADING_MESSAGE') }}</span>
    </div>
  </section>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import { VeTable } from 'vue-easytable';
import { getCountryFlag } from 'dashboard/helper/flag';

import Spinner from 'shared/components/Spinner.vue';
import Thumbnail from 'dashboard/components/widgets/Thumbnail.vue';
import EmptyState from 'dashboard/components/widgets/EmptyState.vue';
import timeMixin from 'dashboard/mixins/time';
import rtlMixin from 'shared/mixins/rtlMixin';
import alertMixin from 'shared/mixins/alertMixin';
import { mapGetters } from 'vuex';
import { frontendURL } from '../../../../helper/URLHelper';
import router from '../../..';
import ContainerCheckbox from './ContainerCheckbox.vue';
import agentMixin from '../../../../mixins/agentMixin';

export default {
  components: {
    EmptyState,
    Spinner,
    VeTable,
  },
  mixins: [alertMixin, clickaway, timeMixin, rtlMixin, agentMixin],
  props: {
    contactsIds: {
      type: Array,
      default: () => [],
    },
    pageSize: {
      type: Number,
      default: 15,
    },
    showSearchEmptyState: {
      type: Boolean,
      default: false,
    },
    onClickContact: {
      type: Function,
      default: () => {},
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    activeContactId: {
      type: [String, Number],
      default: '',
    },
    sortParam: {
      type: String,
      default: 'last_activity_at',
    },
    sortOrder: {
      type: String,
      default: 'desc',
    },
    isContactsDelete: {
      type: Boolean,
      default: false,
    },
    selectContactsDelete: {
      type: Function,
      default: () => {},
    },
    selectedContacts: {
      type: Array,
      default: () => [],
    },
    selectAllContacts: {
      type: Function,
      default: () => {},
    },
    allContactsSelected: {
      type: Boolean,
      default: false,
    },
    selectContactsLength: {
      type: Number,
      default: 0,
    },
    onSearchSubmit: {
      type: Function,
      default: () => {},
    },
    searchQuery: {
      type: String,
      default: '',
    },
    onInputSearch: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      checkboxOption: {
        selectedRowChange: ({ isSelected, selectedRowKeys }) => {
          this.showCheckBoxSelectAll = !isSelected;
          this.$emit('select-contacts-delete', selectedRowKeys);
        },
        selectedAllChange: ({ isSelected, selectedRowKeys }) => {
          this.showCheckBoxSelectAll = !isSelected;
          this.$emit('select-contacts-delete', selectedRowKeys);
        },
      },
      showCheckBoxSelectAll: true,
      sortConfig: {},
      currentPage: 1,
      sortOption: {
        sortAlways: true,
        sortChange: params => this.$emit('on-sort-change', params),
      },
      averageCellWidth: 240,
      isWhatsappInbox: false,
      contactSelected: null,
      showConversationModal: false,
      isChecked: false,
      checkAllContacts: false,
      checkedId: '',
      tableList: [],
      loadingNewConversation: {},
      fetchedPage: 1,
      isFetchingMore: false,
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      activeInbox: 'getSelectedInbox',
      currentUserID: 'getCurrentUserID',
      inboxes: 'inboxes/getInboxes',
      currentUser: 'getCurrentUser',
      contacts: 'contacts/getContactsViews',
      meta: 'contacts/getMeta',
    }),
    totalPages() {
      return (
        Math.ceil(
          (this.meta.count - this.selectedContacts.length) / this.pageSize
        ) || 1
      );
    },
    verifyContacts() {
      return this.isContactsDelete;
    },
    contactConversations() {
      const currentId = this.currentUser?.id;
      const currentConversations = this.$store.getters[
        'contactConversations/getContactConversation'
      ](
        this.contactId,
        currentId,
        this.isLimitedAgent,
        !this.isPermissionSeeAllTeamConversation
      );
      return currentConversations;
    },
    openConversations() {
      if (this.activeInbox) {
        return this.contactConversations.filter(
          conversation =>
            conversation.inbox_id === this.activeInbox &&
            conversation?.meta?.channel !== 'Channel::Internal' &&
            conversation.status !== 'resolved'
        );
      }

      return this.contactConversations.filter(
        conversation => conversation.status !== 'resolved'
      );
    },
    tableData() {
      if (this.isLoading) return [];
      const filtered = (this.contacts || []).filter(
        contact =>
          contact &&
          contact.id !== undefined &&
          !contact.__empty &&
          !this.selectedContacts.some(id => String(id) === String(contact.id))
      );
      if (filtered.length < 15) {
        return [
          ...filtered,
          ...Array(15 - filtered.length).fill({ __empty: true }),
        ];
      }
      return filtered;
    },
    columns() {
      return [
        {
          field: 'name',
          key: 'name',
          title: this.$t('CONTACTS_PAGE.LIST.TABLE_HEADER.NAME'),
          display: 'flex',
          property: 'name',
          rowKey: ({ row }) => row.id,
          fixed: 'left',
          align: this.isRTLView ? 'right' : 'left',
          sortBy: this.sortConfig.name || '',
          width: this.averageCellWidth,
          renderBodyCell: ({ row }) => (
            <ContainerCheckbox
              mouseenter={() => this.onCardHove(row.id)}
              mouseleave={() => this.onCardLeave()}
            >
              <div
                onClick={() => this.onClickContact(row.id)}
                class="row--user-block"
              >
                {this.checkedId === row.id ? (
                  <label class="checkbox-wrapper">
                    <input
                      value={this.isSelected(row.id)}
                      checked={this.isSelected(row.id)}
                      class="checkbox"
                      type="checkbox"
                      onChange={() => this.handleSelected(row.id)}
                    />
                  </label>
                ) : (
                  <Thumbnail
                    src={row.thumbnail}
                    size="32px"
                    username={row.name}
                    status={row.availability_status}
                  />
                )}
                <div class="user-block">
                  <h6 class="sub-block-title text-truncate">
                    <router-link
                      to={`/app/accounts/${this.$route.params.accountId}/contacts/${row.id}`}
                      class="user-name"
                    >
                      {row.name}
                    </router-link>
                  </h6>
                </div>
              </div>
            </ContainerCheckbox>
          ),
        },
        {
          field: 'phone_number',
          key: 'phone_number',
          sortBy: this.sortConfig.phone_number || '',
          title: this.$t('CONTACTS_PAGE.LIST.TABLE_HEADER.PHONE_NUMBER'),
          align: this.isRTLView ? 'right' : 'left',
          width: this.averageCellWidth,
        },
        {
          field: 'company',
          key: 'company',
          sortBy: this.sortConfig.company_name || '',
          title: this.$t('CONTACTS_PAGE.LIST.TABLE_HEADER.COMPANY'),
          align: this.isRTLView ? 'right' : 'left',
        },
        {
          field: 'city',
          key: 'city',
          sortBy: this.sortConfig.city || '',
          title: this.$t('CONTACTS_PAGE.LIST.TABLE_HEADER.CITY'),
          align: this.isRTLView ? 'right' : 'left',
        },
        {
          field: 'country',
          key: 'country',
          title: this.$t('CONTACTS_PAGE.LIST.TABLE_HEADER.COUNTRY'),
          align: this.isRTLView ? 'right' : 'left',
          sortBy: this.sortConfig.country || '',
          renderBodyCell: ({ row }) => {
            if (row.country) {
              return (
                <div class="text-truncate">
                  {`${getCountryFlag(row.countryCode)} ${row.country}`}
                </div>
              );
            }
            return '---';
          },
        },
      ];
    },
  },
  watch: {
    currentPage() {
      this.fetchContacts();
    },
    sortOrder() {
      this.setSortConfig();
    },
    sortParam() {
      this.setSortConfig();
    },
    selectedContacts() {
      this.fetchTableList();
    },
    contacts: {
      handler: 'fetchTableList',
      immediate: true,
      deep: true,
    },

  },
  mounted() {
    this.fetchContacts();
    this.setSortConfig();
  },
  methods: {
    fetchContacts() {
      this.$store.dispatch('contacts/getCampaignListContacts', {
        page: this.currentPage,
        contactsIds: this.selectedContacts,
      });
    },
    goToPage(page) {
      if (page < 1 || page > Math.ceil(this.meta.count / 15)) return;
      this.currentPage = page;
    },
    handleSelected(id) {
      return this.$emit('select-contacts', id);
    },
    onCardHove(id) {
      this.checkedId = id;
      this.isChecked = true;
    },
    onCardLeave() {
      if (this.verifyContacts) {
        this.checkedId = '';
        this.isChecked = false;
      }
    },
    isSelected(id) {
      return this.selectedContacts.includes(id);
    },
    handleSelectAll(e) {
      this.$emit('select-all-contacts', e);
    },
    setSortConfig() {
      this.sortConfig = { [this.sortParam]: this.sortOrder };
    },

    async fetchTableList() {
      const filteredContacts = (this.contacts || []).filter(
        contact =>
          contact &&
          contact.id !== undefined &&
          !contact.__empty &&
          !this.selectedContacts.some(id => String(id) === String(contact.id))
      );
      this.tableList = filteredContacts;
      if (this.tableList.length < 11 && this.currentPage < this.totalPages) {
        await this.fetchContacts();
      }
    },
    fetchTableList() {
      // Filtra contatos que NÃO estão selecionados
      const filteredContacts = this.contacts.filter(
        contact => !this.selectedContacts.some(id => String(id) === String(contact.id))
      );
      this.tableList = filteredContacts;
      if (
        this.tableList.length < 11 &&
        this.currentPage < this.totalPages
      ) {
        this.fetchContacts();
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~dashboard/assets/scss/mixins';

.contacts-table-wrap {
  flex: 1 1;
  overflow: hidden;
}

.flex {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.text-truncate a {
  color: var(--g-20);
}

.contacts-table-wrap::v-deep {
  .ve-table {
    padding-bottom: var(--space-large);
    margin-right: 5px;
    height: 450px;
  }
  .new-message {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 2.2rem !important;
    width: 2.2rem !important;
  }
  .row--user-block {
    align-items: center;
    display: flex;
    text-align: left;
    white-space: nowrap;

    .user-block {
      align-items: flex-start;
      display: flex;
      flex-direction: column;
      margin: 0 var(--space-small);
    }

    .user-name {
      font-size: var(--font-size-small);
      font-weight: var(--font-weight-medium);
      margin: 0;
      text-transform: capitalize;
      white-space: normal;
    }

    .view-details--button {
      color: var(--color-body);
    }

    .user-email {
      margin: 0;
    }

    .user-email-white {
      white-space: normal;
      overflow-wrap: break-word;
    }
  }

  .ve-table-header-th {
    padding: var(--space-small) var(--space-two) !important;
  }

  .ve-table-body-td {
    padding: var(--space-small) var(--space-two) !important;
  }
  td label.ve-checkbox {
    position: relative !important;
    z-index: 1 !important;
    left: 7% !important;
    top: 50% !important;
    white-space: nowrap !important;
  }
  .ve-table-body-td:first-child {
    height: 80px !important;
  }

  .ve-checkbox {
    font-size: 15px;
  }

  .hidden-label-parent
    .ve-table-header-th.ve-table-fixed-left.ve-table-last-left-fixed-column
    label {
    display: none !important;
  }

  .ve-checkbox .ve-checkbox-indeterminate .ve-checkbox-inner:after {
    top: 50% !important;
    left: 50% !important;
    width: 8px !important;
    height: 8px !important;
    background-color: #108ee9;
    border: 0;
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
    content: ' ';
  }

  .bulk-action__panel {
    cursor: pointer;

    span {
      font-size: var(--font-size-mini);
      margin: 0 var(--space-smaller);
    }

    input[type='checkbox'] {
      cursor: pointer;
      margin: var(--space-zero);
    }
  }

  span.ve-checkbox-content span.ve-checkbox-inner {
    width: 13px;
    height: 13px;
  }

  tr.ve-checkbox-inner:after {
    width: 13px;
    height: 13px;
  }
  .ve-checkbox-content.ve-checkbox-checked {
    width: 13px;
    height: 13px;
  }

  .ve-checkbox-content .ve-checkbox-inner:after {
    left: 3px;
    top: 0px;
    width: 6px;
    height: 9px;
  }

  .ve-table-body-tr:last-child {
    height: 80px !important;
  }

  .ve-table-header-th {
    font-size: var(--font-size-mini) !important;
  }
  .ve-table-sort {
    top: -4px;
  }
}

.contacts--loader {
  align-items: center;
  display: flex;
  font-size: var(--font-size-default);
  justify-content: center;
  padding: var(--space-big);
}

.cell--social-profiles {
  a {
    color: var(--s-300);
    display: inline-block;
    font-size: var(--font-size-medium);
    min-width: var(--space-large);
    text-align: center;
  }
}

.ve-table *,
.ve-table *:before,
.ve-table *:after {
  box-sizing: border-box;
  margin: 0 5px 0 0;
  padding: 0;
  text-overflow: ellipsis;
  overflow: hidden !important;
}

.checkbox-wrapper {
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  border-radius: 100%;
  margin-top: 0px;
  cursor: pointer;

  &:hover {
    background-color: var(--w-100);
  }

  input[type='checkbox'] {
    margin: 0px !important;
    cursor: pointer;
  }
  .search-header {
    display: flex;
  }
}
.search-wrap {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  width: 100%;
  padding: 10px;
}
.contact-added-search {
  margin: 0;
  height: 3.8rem;
  width: 40% !important;
  padding-left: var(--space-large);
  padding-right: 6rem;
  border-color: var(--s-100);
}

.pagination-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin: 1rem 0;
}

.pagination-btn {
  min-width: 36px;
  min-height: 36px;
  font-size: 1.3rem;
  border: none;
  background: #f5f7fa;
  color: #2d3a4a;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagination-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination-current {
  font-size: 1.1rem;
  font-weight: 600;
  padding: 0 10px;
  color: #2d3a4a;
}
</style>
